<template>
  <div class="footer">
    <div class="copy-right">
      <p>Copyright © 新型电力系统博士生创新论坛. All rights reserved.</p>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: "",
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
  components: {},
};
</script>

<style scoped lang="less">
.footer {
  width: 100%;
  height: 172px;
  background: url("../../assets/image/footerbg.png") no-repeat top center;
  .copy-right {
  
    margin: 0px auto;

    text-align: center;
    font-size: 14px;
  
    color: #fff;
    p {
      margin: 0;
      padding: 0;
      line-height: 172px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue